export const getters = {
  semesters(state) {
    return state.semesters;
  },
  semestersById(state) {
    const byId = {};
    state.semesters.forEach((e) => (byId[e.id] = e));
    return byId;
  },
  semesterByDate: (state) => (date) => {
    const targetDate = new Date(date);
    const semester = state.semesters.find((e) => {
      const startDate = new Date(e.fromDate);
      const endDate = new Date(e.toDate);
      return targetDate >= startDate && targetDate <= endDate;
    });

    return semester || null;
  },
  closestSemesterByDate: (state) => (date) => {
    const targetDate = new Date(date);
    const schoolYear = targetDate.getFullYear();
    const semesters = state.semesters.filter((e) => e.schoolYear == schoolYear);
    if (semesters.length === 0) return null;

    let closestSemester = semesters[0];
    let minDifference = Math.abs(new Date(closestSemester.fromDate) - targetDate);

    semesters.forEach((semester) => {
      const startDate = new Date(semester.fromDate);
      const difference = Math.abs(startDate - targetDate);

      if (difference < minDifference) {
        closestSemester = semester;
        minDifference = difference;
      }
    });
    return closestSemester;
  },
};
